import { useCallback } from "react";
import { useAccount, useWriteContract } from "wagmi";
import { waitForTransactionReceipt } from "@wagmi/core";
import { parseUnits, parseEther } from "viem";
import institusionAbi from "../../utils/institusion.json";
import Environment from "../../utils/Environment";
import { wagmiConfig } from "../../wagmiConfig";

const usePurchaseUsdt1 = () => {
  const { address: account, isConnected } = useAccount();
  const { writeContractAsync } = useWriteContract();

  const UsdtAddress = Environment.busd;

  const purchaseUsdt1 = useCallback(
    async (amount, postApiRes, id, balance, min, stakeIndex) => {
      if (!isConnected || !account) throw new Error("WALLET_NOT_CONNECTED");

      amount = parseFloat(amount).toFixed(6);
      const roundedAmount = Math.round(amount * 1e12) / 1e12;
      const nd = parseUnits(roundedAmount.toString(), 6);

      let minValue = Math.round(parseFloat(min * 0.99).toFixed(6) * 1e12) / 1e12;
      minValue = parseEther(minValue.toString());

      console.log(UsdtAddress, nd, postApiRes.code, postApiRes?.normalizationFactor, postApiRes.referenceTokenPrice, id, postApiRes.price, postApiRes.deadline);

      try {
        const hash = await writeContractAsync({
          address: Environment.instituson,
          abi: institusionAbi,
          functionName: "purchaseWithToken",
          args: [
            UsdtAddress,
            nd,
            postApiRes.code,
            postApiRes?.normalizationFactor,
            postApiRes.referenceTokenPrice,
            minValue,
            id,
            postApiRes.price,
            postApiRes.deadline,
            postApiRes?.v,
            postApiRes?.r,
            postApiRes?.s,
          ],
        });

        console.log("USDT1 tx hash:", hash);

        const receipt = await waitForTransactionReceipt(wagmiConfig, { hash });

        console.log("USDT1 purchase confirmed:", receipt);

        return { transactionHash: hash, receipt };
      } catch (error) {
        console.error("USDT1 purchase error:", error);
        throw error;
      }
    },
    [account, isConnected, writeContractAsync]
  );

  return { purchaseUsdt1 };
};

export default usePurchaseUsdt1;
